import React, { useState, useEffect } from 'react';
import './style.css';

const TestType = ({
  text = '',
  active = false,
  type = '',
  onStateChange = () => {},
}) => {
  const [isActive, setActive] = useState(!!active);

  useEffect(() => {
    setActive(active);
  }, [active]);

  return (
    <button
      className={`test-type-container ${isActive && 'test-type-active'}`}
      onClick={() => {
        setActive(!isActive);
        onStateChange(type, !isActive);
      }}>
      {text}
    </button>
  );
};

export default TestType;
